import * as angular from "angular";
import {$bringozFactory} from "../persistence-layer/bringoz-factory.factory";
import {BringozApi} from "../persistence-layer/models/bringoz-api.model";
import {DataStoreConfig} from "../persistence-layer/models/datastore-config.model";

angular
  .module('bringoz.admin.schedule')
  .factory('$schedule', scheduleObjectFactory);

function scheduleObjectFactory($bringozFactory: $bringozFactory,
                               ScheduleAPI: BringozApi,
                               Schedule_DS: DataStoreConfig) {

  function $schedule(id: string) {
    return $bringozFactory(id, ScheduleAPI, Schedule_DS)
  }

  return $schedule
}
